import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import useAuth from "../hooks/useAuth";
import useMatricula from "../hooks/useMatricula";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";
import GruposHabilitados from "./GruposHabilitados";

const GruposHabilitadosSkeleton = () => (
  <div className="accordion accordion-payment mt-3">
    {[0, 1, 2].map((item) => (
      <div className="accordion-item" key={item}>
        <div className="accordion-header px-3 py-3">
          <Skeleton width="60%" height={18} />
        </div>
        <div className="accordion-body px-3">
          <Skeleton width="30%" height={14} className="mb-2" />
          <Skeleton height={38} className="mb-1" />
          <Skeleton height={38} className="mb-1" />
          <Skeleton height={38} />
        </div>
      </div>
    ))}
  </div>
);

const ModalGruposHabilitados = () => {
  const { gruposHabilitados, listadoAsignaturas, franjaSeleccionadaAsignaturas, multifranjas, cargandoGrupos, setCargandoGrupos } = useMatricula();
  const [desPrograma, setDesPrograma] = useState("");

  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});

  let [gruposHabilitadosFiltrar, setGruposHabilitadosFiltrar] = useState([]);
  const [listGruposEquivalenteArmados, setGruposEquivalenteArmados] = useState(
    []
  );

  useEffect(() => {
    const armarArrayDeGrupos = () => {
      let allAsignaguraXgrupos = listadoAsignaturas.map((e) => {
        let equivalentes = [];
        let itemsEquivalentes = [];

        gruposHabilitados.forEach((g) => {
          if (g.scurso == e.scurso) {
             

            itemsEquivalentes = [...itemsEquivalentes, g];
          }
        });

        gruposHabilitados.forEach((g) => {
          if (g.scurso == e.scurso) {
            if (
              equivalentes.some((som) => som.sequivalente == g.sequivalente) ==
              false
            ) {
              let itemEqui = [];
              itemsEquivalentes.forEach((f) => {
                if (f.sequivalente == g.sequivalente && f.scurso == g.scurso) {
                  itemEqui = [...itemEqui, { f }];
                }
              });

              let totalAsignados = itemEqui.filter((e)=> e.f.basignado==true ).length;
              
              equivalentes = [
                ...equivalentes,
                {
                  sequivalente: g.sequivalente,
                  dequivalente: g.dequivalente,
                  dcurso: e.dcurso,
                  scurso: e.scurso,
                  ItemsEqui: itemEqui,
                  basignado: totalAsignados===0?false:true
                },
              ];
            }
          }
        });

        let armarCadena = {
          nombreAsignatura: e.scurso + "-" + e.dcurso,
          sumilla: e.dsumilla,
          equivalentes,
          basignado: e.binscrito
        };
       

        return armarCadena; 
      });

     

      return allAsignaguraXgrupos;
    };
    if (gruposHabilitados.length > 0 && listadoAsignaturas.length > 0) {
      setGruposEquivalenteArmados(armarArrayDeGrupos());
      setCargandoGrupos(false);
    }
  }, [gruposHabilitados, listadoAsignaturas]);

  useEffect(() => {
    const obtenerPrograma = () => {
      if (gruposHabilitados.length > 0) {
        setDesPrograma(gruposHabilitados[0].dprograma);
      }
    };
    obtenerPrograma();
 
    let datas;
    let hash = {};
    datas = gruposHabilitados.filter((o) =>
      hash[o.scurso] ? false : (hash[o.scurso] = true)
    );
    setGruposHabilitadosFiltrar(datas);
  }, [gruposHabilitados]);

  useEffect(() => {
    
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        grupos_msj_lista: obtenerLabelEtiqueta(
          "lbl_grupos_msj_lista",
          listadoEtiquetas
        ),
        global_programa: obtenerLabelEtiqueta(
          "lbl_global_programa",
          listadoEtiquetas
        ),
        sumilla_aceptar: obtenerLabelEtiqueta(
          "lbl_sumilla_aceptar",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);
  const { grupos_msj_lista, global_programa, sumilla_aceptar } = etiquetas;

  return (
    <div
      className="modal fade"
      id="grupos"
      tabIndex="-1"
      aria-labelledby="gruposLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title text-uppercase" id="gruposLabel">
              {
                multifranjas && <strong> FRANJA {franjaSeleccionadaAsignaturas} - </strong>  
              }
               {grupos_msj_lista}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body modal-groups">
            <p className=" fw-medium  mb-0 text-uppercase fw-medium">
              {global_programa} {cargandoGrupos ? <Skeleton width={120} height={14} inline /> : desPrograma}:
            </p>

            {cargandoGrupos ? (
              <GruposHabilitadosSkeleton />
            ) : (
              listGruposEquivalenteArmados.map((data, index) => {
                return (

                  <div key={index} className="accordion accordion-payment mt-3" id="accordionExampleSincro">{<GruposHabilitados dataAll={data} index={index} />}</div>
                );
              })
            )}

          </div>

          <div className="modal-footer text-center">
            <button
              type="button"
              className="btn btn-primary text-center"
              data-bs-dismiss="modal"
            >
              {sumilla_aceptar}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalGruposHabilitados;
